import React from 'react'
import { useRoadmapStore } from '../../stores/projetos/roadmapStore'
import ItemCard from './ItemCard'

const columns = [
  { key: 'ideia', title: 'Ideia' },
  { key: 'planejado', title: 'Planejado' },
  { key: 'em_andamento', title: 'Em andamento' },
  { key: 'bloqueado', title: 'Bloqueado' },
  { key: 'concluido', title: 'Concluído' }
] as const

export const RoadmapKanban: React.FC = () => {
  const { items, labels } = useRoadmapStore()
  const labelsMap = React.useMemo(() => Object.fromEntries(labels.map(l => [l.id, l])), [labels])

  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
      {columns.map(col => {
        const colItems = items.filter(i => i.status === col.key)
        return (
          <div key={col.key} className="bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-600 p-3 flex flex-col min-h-[300px]">
            <div className="text-sm font-semibold text-gray-900 dark:text-white mb-2">{col.title}</div>
            <div className="space-y-2 flex-1 overflow-y-auto">
              {colItems.length === 0 ? (
                <div className="text-xs text-gray-500 dark:text-gray-400">Sem itens.</div>
              ) : (
                colItems.map(it => <ItemCard key={it.id} item={it} labelsMap={labelsMap} />)
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default RoadmapKanban


